import React from 'react';
import DashCard from '../components/DashCard';
import TreeMap from '../components/TreeMap';
const TopQEProject = _ref => {
  let {
    dashboardData
  } = _ref;
  const {
    top_projects_with_qe: topQEProjects
  } = dashboardData;
  const data = topQEProjects.map(project => {
    return {
      x: project.project_name,
      y: project.total_qe
    };
  });
  const colors = ['#80bbdc', '#00b08b', '#a20a42', '#8b2885', '#684198', '#00aeef'];
  return /*#__PURE__*/React.createElement(DashCard, {
    title: `Top 10 Project QE for ${dashboardData.current_accounting_period}`,
    className: "h-100 dashboard-top-projects-tree-map"
  }, /*#__PURE__*/React.createElement(TreeMap, {
    data: data,
    colors: colors
  }));
};
export default TopQEProject;